import React from 'react';
import s from './InputCurrency.scss'

const SelectCar = ({
    value,
    name,
    className = '',
    options,
    onChange,
    errors
}) => {
    return(
        <div className={`${s.container} ${className}`}>
            <select
                name={`${name}`}
                onChange={onChange}
                className={s.selectCar}
            >
                {options && options.map((option, index) => option.name ? (
                    <option key={index} value={option.id} selected={value && option.id == value.id || option.id == value} >{option.name}</option>
                )
                :
                (
                    <option key={index} value={option.id} selected={option == value} >{option}</option>                
                )
                )}
            </select>
            {errors && <p autoFocus className={s.error}>{errors[0]}</p>}
        </div>
    );
}
export default SelectCar
